import React from 'react';
import { Tooltip } from 'antd';

export const Steps = ({
                          current = 0,
                          onChange = () => {
                          },
                          children,
                          className,
                          ariaLabel,
                          style = {},
                      }) => {
    const count = React.Children.count(children);

    return (
        <div
            className={className}
            role="list"
            aria-label={ariaLabel}
            style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                overflowX: 'auto',
                ...style,
            }}
        >
            {React.Children.map(children, (child, index) => {
                const isLast = index === count - 1;
                const disabled = child.props.disabled === true;

                const stepNode = React.cloneElement(child, {
                    index,
                    isActive: index === current,
                    isClickable: !disabled,
                    disabled,
                    onClick: () => {
                        if (!disabled) onChange(index);
                    },
                    onKeyDown: (e) => {
                        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
                            e.preventDefault();
                            onChange(index);
                        }
                    },
                    tabIndex: !disabled ? 0 : -1,
                    ariaCurrent: index === current ? 'step' : undefined,
                });

                return (
                    <React.Fragment key={index}>
                        {stepNode}
                        {!isLast && (
                            <div
                                style={{
                                    flex: '1 1 auto',     // flexible separator
                                    height: 2,
                                    backgroundColor: '#ccc',
                                    margin: '0 8px',
                                    opacity: disabled ? 0.3 : 1,
                                }}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export const Step = ({
                         title,
                         status = 'wait', // 'wait' | 'process' | 'finish' | 'skip' | 'end'
                         icon,
                         isActive,
                         isClickable,
                         disabled,
                         onClick,
                         onKeyDown,
                         tabIndex,
                         data,
                         className,
                         ariaLabel,
                         ariaCurrent
                     }) => {
    let bgColor = '#fff';
    let borderColor = '#ccc';
    let textColor = '#666';

    if (status === 'finish') {
        bgColor = '#52c41a';
        borderColor = '#52c41a';
        textColor = '#fff';
    } else if (isActive || status === 'process') {
        bgColor = '#1890ff';
        borderColor = '#1890ff';
        textColor = '#fff';
    } else if (status === 'skip') {
        bgColor = '#faad14';
        borderColor = '#faad14';
        textColor = '#fff';
    } else if (status === 'end') {
        bgColor = '#722ed1';
        borderColor = '#722ed1';
        textColor = '#fff';
    }

    if (disabled) {
        bgColor = '#f5f5f5';
        borderColor = '#ddd';
        textColor = '#aaa';
    }

    const dataAttrs = {};
    if (data && typeof data === 'object') {
        Object.entries(data).forEach(([key, value]) => {
            if (value === undefined) return;

            // convert camelCase → kebab-case for data-* attribute
            const attrName =
                'data-' + key.replace(/([A-Z])/g, '-$1').toLowerCase();

            dataAttrs[attrName] =
                typeof value === 'object' ? JSON.stringify(value) : value;
        });
    }

    const stepContent = (
        <div
            onClick={isClickable && !disabled ? onClick : undefined}
            onKeyDown={onKeyDown}
            tabIndex={tabIndex}
            className={className}
            aria-label={ariaLabel}
            aria-current={ariaCurrent}
            role={isClickable && !disabled ? 'button' : 'listitem'}
            {...dataAttrs}
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: disabled ? 'not-allowed' : isClickable ? 'pointer' : 'default',
                opacity: disabled ? 0.5 : 1,
            }}
        >
            <div
                style={{
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    backgroundColor: bgColor,
                    border: `2px solid ${borderColor}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {icon || <span style={{ fontSize: 12, color: textColor }} />}
            </div>
        </div>
    );

    return (
        <Tooltip title={title} placement="top" mouseEnterDelay={0.2}>
            {stepContent}
        </Tooltip>
    );
};

